// extracted by mini-css-extract-plugin
export var Reviews = "Reviews-module--Reviews--1YzPE";
export var Stars = "Reviews-module--Stars--CuLZ3";
export var Review = "Reviews-module--Review--k1aCq";
export var MobileButtons = "Reviews-module--MobileButtons--3m2lP";
export var Text = "Reviews-module--Text--1efDQ";
export var Name = "Reviews-module--Name--tjKHQ";
export var glow = "Reviews-module--glow--2Qhiv";